import React, {useEffect} from 'react';
import {observer} from 'mobx-react';
import ModalSimple from '../../../../../global/modal-simple';
import {runInAction} from 'mobx';
import FormMultilineShipments from '../form-multiline-shipments/form-multiline-shipments';
import {buttonMultilineShipmentsStore} from './button-multiline-shipments-store';
import ButtonImportCsv from '../button-import-csv/button-import-csv';
import {checkout} from '../../../../../api';

type Props = {
    cartItem: ICartLineItem;
};

const ButtonMultilineShipments = observer(({cartItem}: Props) => {
    const modalId = `modal-multiline-shipments-${cartItem.id}`;

    useEffect(() => {
        watchModalOpen();
    }, [modalId]);

    useEffect(() => {
        runInAction(() => {
            // approved ria
            buttonMultilineShipmentsStore.getAddressLines(cartItem);
        });
    }, [cartItem.id, cartItem.qty]);

    const watchModalOpen = () => {
        const modal = document.getElementById(modalId);

        if (!modal) {
            return;
        }

        const observer = new MutationObserver(mutations => {
            mutations.forEach(async mutation => {
                if (mutation.attributeName === 'style' && modal.style.display === 'block') {
                    await checkout('get-cart');
                }
            });
        });

        observer.observe(modal, {attributes: true, attributeFilter: ['style']});

        return () => observer.disconnect();
    };

    return (
        <div className="multiline-shipments-container">
            <ModalSimple
                id={modalId}
                title="Multiline Shipments"
                closeButtonText="Save & Close"
                saveAndClose={() => buttonMultilineShipmentsStore.saveAddress()}
                closeButtonDisabled={buttonMultilineShipmentsStore.saveButtonDisabled(cartItem.address)}
            >
                <div className="shipping-box">
                    {cartItem.address?.map((i, index) => (
                        <div
                            key={index}
                            className="item-container"
                        >
                            <div className="item">
                                <div>
                                    <span>Shipping Address {index + 1}</span>
                                    {!buttonMultilineShipmentsStore.expandedIndexes.includes(index) && <div className="address">{buttonMultilineShipmentsStore.address(i)}</div>}
                                </div>
                                <button
                                    className="change"
                                    onClick={() => buttonMultilineShipmentsStore.expandForm(index)}
                                >
                                    {buttonMultilineShipmentsStore.expandedIndexes.includes(index) ? '' : 'Change'}
                                </button>
                            </div>
                            {buttonMultilineShipmentsStore.expandedIndexes.includes(index) && (
                                <>
                                    <FormMultilineShipments address={i} />
                                    <div className="form-buttons">
                                        <button
                                            className="btn btn-primary btn-clear"
                                            type="button"
                                            aria-label="Clear entered shipping address"
                                            onClick={() => buttonMultilineShipmentsStore.clearAddress(cartItem, index)}
                                        >
                                            Clear Address
                                        </button>
                                        <button
                                            className="btn btn-primary btn-save"
                                            type="button"
                                            aria-label="Save entered shipping address"
                                            disabled={buttonMultilineShipmentsStore.formInvalid(i)}
                                            onClick={() => buttonMultilineShipmentsStore.collapseForm(index)}
                                        >
                                            Save Address
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                    ))}

                    <div className="shipping-bottom">
                        <ButtonImportCsv cartItem={cartItem} />

                        {!buttonMultilineShipmentsStore.expandedIndexes.length && (
                            <button
                                type="button"
                                className="btn-checkout btn-checkout-white btn-shipping-white"
                                aria-label="Clear all entered shipping addresses"
                                onClick={() => buttonMultilineShipmentsStore.clearAllAddresses(cartItem)}
                            >
                                Clear All
                            </button>
                        )}
                    </div>
                </div>
            </ModalSimple>

            <button
                type="button"
                className="btn-checkout btn-checkout-white btn-multiline-shipments"
                aria-label="Multiline Shipments"
                onClick={() => buttonMultilineShipmentsStore.openModal(cartItem.id)}
            >
                Multiline Shipments
            </button>
        </div>
    );
});

export default ButtonMultilineShipments;
